// import axios from 'axios';
// import { apiUrl } from '../config';

// const API_URL = apiUrl;


// const instance = axios.create({
//    baseURL: API_URL
// })

// class AuthService {
//   post(postData) {
//     console.log(postData)
//     let user = localStorage.getItem('user')
//     user = JSON.parse(user)
 
//     const authToken = 'Bearer ' + user['access'];

//     console.log(authToken)
   
//     // console.log('auth service post data',typeof(postData))
//     return instance.post(API_URL + 'posts/', postData, {
//       headers: {
//       'Authorization': authToken,
//       'Content-Type': 'multipart/form-data'
//       },
//     })
//     .then((res) => {
//       console.log(res)
      
//       let newPost = res;
//       // commit("SUBMIT_POST", newPost);
//       return res
//     })
//     .catch(error => {
//       console.error('Error adding post:', error);
//       // ... handle error condition
//     });
//   }
//   login(user) {
//     return instance
//       .post(API_URL + 'token/pair', {
//         email: user.email,
//         password: user.password
//       })
//       .then(this.handleResponse)
//       .then(response => {
//         if (response.data.user) {
//           localStorage.setItem('user', JSON.stringify(response.data));
//         }
//         return response.data;
//       });
//   }

//   logout() {
//     localStorage.removeItem('user');
//   }

//   register(user) {
//     return instance.post(API_URL + 'users/register/', user)
//     .then(this.handleResponse)
//     .then(response => {
//       // if (response.data.user) {
//       //     let user = response.data.user;
//       //     user['access_token'] = response.data.access_token
//       //     user['refresh_token'] = response.data.refresh_token
//       //     localStorage.setItem('user', JSON.stringify(user));
//       //   }
//         return response.data;
//     });
//   }

//   handleResponse(response) {
//     if (response.status === 401) {
//       this.logout();
//       location.reload(true);

//       const error = response.data && response.data.message;
//       return Promise.reject(error);
//     }

//     return Promise.resolve(response);
//   }
// }

// export default new AuthService();


import axios from 'axios';
import { apiUrl } from '../config';

const API_URL = apiUrl;

const instance = axios.create({
   baseURL: API_URL
})

class AuthService {
  post(postData) {
    console.log(postData);
    let user = localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
    } else {
      console.error('No user is logged in');
      return Promise.reject('No user is logged in');
    }

    const authToken = 'Bearer ' + user['access'];
    console.log(authToken);
   
    return instance.post('posts/', postData, {  // No need for API_URL
      headers: {
        'Authorization': authToken,
        'Content-Type': 'multipart/form-data'
      },
    })
    .then((res) => {
      console.log(res);
      // let newPost = res;
      return res;
    })
    .catch(error => {
      console.error('Error adding post:', error);
    });
  }

  login(user) {
    return instance
      .post('token/pair', {
        email: user.email,
        password: user.password
      })
      .then(response => this.handleResponse(response))  // Arrow function ensures context
      .then(response => {
        if (response.data.user) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return instance.post('users/register/', user)
      .then(response => this.handleResponse(response))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error during registration:', error);
      });
  }

  handleResponse(response) {
    if (response.status === 401) {
      this.logout();
      location.reload();  // Updated without argument

      const error = response.data && response.data.message;
      return Promise.reject(error);
    }

    return Promise.resolve(response);
  }
}

export default new AuthService();
